<template>
  <p>
    <pu-low-results-search-link :modify-filters="{ priceRange: {} }">
      <translate>Remove the price filter</translate>
      (
      <template v-if="hasMinPrice && hasMaxPrice">
        <pu-price-rounded :price="minPrice" />
        -
        <pu-price-rounded :price="maxPrice" />
      </template>
      <template v-else-if="hasMinPrice">
        <i18n-t keypath="Min: {minPrice}">
          <template #minPrice>
            <pu-price-rounded :price="minPrice" />
          </template>
        </i18n-t>
      </template>
      <template v-else-if="hasMaxPrice">
        <i18n-t keypath="Max: {maxPrice}">
          <template #maxPrice>
            <pu-price-rounded :price="maxPrice" />
          </template>
        </i18n-t>
      </template>
      )
    </pu-low-results-search-link>
  </p>
</template>
<script lang="ts">
import type { PriceRange } from '../../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { isUndefined } from 'lodash-es'

@Component
class LowResultsPriceRange extends Vue {
  @Prop()
  priceRange: PriceRange

  get minPrice() {
    return {
      amount: (this.priceRange.min ? this.priceRange.min : 0) * 100,
      currency: 'GBP',
    }
  }

  get maxPrice() {
    return {
      amount: (this.priceRange.max ? this.priceRange.max : 0) * 100,
      currency: 'GBP',
    }
  }

  get hasMinPrice() {
    return !isUndefined(this.priceRange.min)
  }

  get hasMaxPrice() {
    return !isUndefined(this.priceRange.max)
  }
}

export default toNative(LowResultsPriceRange)
</script>
<style scoped>
p :deep(.display-price) {
  font-weight: normal;
}
</style>
